import React from 'react';
import { Row, Col, Button, Select, Typography, Space } from 'antd';

const { Text } = Typography;

export interface IStatusOption {
    label: string;
    value: string | boolean;
}

export interface HeaderAcoesTabelaProps {
    // Botão Adicionar
    showAdd?: boolean;
    addText?: string;
    disabledAdd?: boolean;
    onAdd?: () => void;

    // Botão Editar
    showEdit?: boolean;
    editText?: string;
    disabledEdit?: boolean;
    onEdit?: () => void;

    // Filtro de Status (Select)
    showStatus?: boolean;
    statusOptions?: IStatusOption[];
    statusValue?: string | boolean;
    onStatusChange?: (value: any) => void;
    statusPlaceholder?: string;

    // Ações de Ativar / Inativar
    showInativar?: boolean;
    inativarText?: string;
    ativarText?: string;
    isInativoSelected?: boolean;
    onAtivar?: () => void;
    onInativar?: () => void;
    disabledInativar?: boolean;
    disabledAtivar?: boolean;

    // Contadores de itens
    showCounter?: boolean;
    filteredCount?: number;
    totalCount?: number;
    customCounterText?: string;

    // Ações Extras / Customizadas
    extraActions?: React.ReactNode;
    children?: React.ReactNode;

    // Estilo customizado
    style?: React.CSSProperties;
}

const HeaderAcoesTabela: React.FC<HeaderAcoesTabelaProps> = ({
    showAdd = true,
    addText = 'Adicionar',
    disabledAdd = false,
    onAdd,

    showEdit = true,
    editText = 'Editar',
    disabledEdit = true,
    onEdit,

    showStatus = false,
    statusOptions = [
        { label: 'Ativos', value: 'Contratos' },
        { label: 'Inativos', value: 'Inativos' }
    ],
    statusValue = 'Contratos',
    onStatusChange,
    statusPlaceholder = 'Selecione...',

    showInativar = false,
    inativarText = 'Inativar',
    ativarText = 'Ativar',
    isInativoSelected = false,
    onAtivar,
    onInativar,
    disabledAtivar = true,
    disabledInativar = true,

    showCounter = true,
    filteredCount = 0,
    totalCount = 0,
    customCounterText,

    extraActions,
    children,
    style
}) => {
    return (
        <div style={{ marginBottom: 16, ...style }}>
            {/* Linha de Botões de Ação */}
            <Row align="middle" style={{ marginBottom: 8 }} gutter={[8, 8]}>
                {showAdd && (
                    <Col>
                        <Button
                            type="primary"
                            className="btn_success_vlhbegoawrgbvr"
                            disabled={disabledAdd}
                            onClick={onAdd}
                            style={{ marginRight: 5, marginBottom: 5 }}
                        >
                            {addText}
                        </Button>
                    </Col>
                )}

                {showEdit && (
                    <Col>
                        <Button
                            type="primary"
                            className="btn_warning_cewuyfgfvewofc"
                            disabled={disabledEdit}
                            onClick={onEdit}
                            style={{ marginRight: 5, marginBottom: 5 }}
                        >
                            {editText}
                        </Button>
                    </Col>
                )}

                {showStatus && (
                    <Col>
                        <Select
                            placeholder={statusPlaceholder}
                            value={statusValue}
                            onChange={onStatusChange}
                            style={{ minWidth: 100, marginRight: 5, marginBottom: 5 }}
                        >
                            {statusOptions.map(opt => (
                                <Select.Option key={String(opt.value)} value={opt.value}>
                                    {opt.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                )}

                {showInativar && (
                    <Col>
                        {isInativoSelected ? (
                            <Button
                                type="primary"
                                className="btn_success_vlhbegoawrgbvr"
                                disabled={disabledAtivar}
                                onClick={onAtivar}
                                style={{ marginRight: 5, marginBottom: 5 }}
                            >
                                {ativarText}
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                danger
                                disabled={disabledInativar}
                                onClick={onInativar}
                                style={{ marginRight: 5, marginBottom: 5 }}
                            >
                                {inativarText}
                            </Button>
                        )}
                    </Col>
                )}

                {extraActions && <Col>{extraActions}</Col>}
                {children && <Col>{children}</Col>}
            </Row>

            {/* Linha de Contagem de Itens */}
            {showCounter && (
                <Row>
                    <Col>
                        <Text type="secondary" style={{ fontSize: '13px' }}>
                            {customCounterText || `Mostrando: ${filteredCount} de ${filteredCount} num total de ${totalCount}`}
                        </Text>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default HeaderAcoesTabela;
